/*jshint esversion: 9 */
import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";
import { doLog } from "../shared/utility";
import Property from "./Property";

class Properties extends Component {
  state = {
    
  };

  addInitialPropertyItem() {
    const propertyFields = null;
    const propertyItem = {
      propertyInstance: 0,
      propertyFields: propertyFields,
    };

    if (doLog()) console.log("[Properties] addInitialPropertyItem propertyItem:", propertyItem);
    this.props.onAddToPropertyArray(this.props.propertyArray, propertyItem);
    return propertyItem;
  }

  checkForEmptyArray() {
    if (
      this.props.selectedIncidentTypeData &&
      this.props.selectedIncidentTypeData !== null &&
      this.props.selectedIncidentTypeData.REQUIREPROPERTYINFO === "Y"
    ) {
      if (doLog()) console.log("[Properties].checkForEmptyArray RequireProperty:" + this.props.selectedIncidentTypeData.REQUIREPROPERTYINFO);
        const arraySize = this.props.propertyArray.length;
        if (doLog()) console.log("[Properties].checkForEmptyArray arraySize:" + arraySize);
        if (arraySize === 0) {
          this.addInitialPropertyItem();
        }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Properties].componentDidMount");
    this.checkForEmptyArray();
  }

  componentDidUpdate() {
    // if (doLog()) console.log("[Properties].componentDidUpdate");
    if (doLog()) console.log("[Properties].componentDidUpdate props:", this.props);
    this.checkForEmptyArray();
  }

  render() {
    if (doLog()) console.log("[Properties].render selectedIncidentTypeData:", this.props.selectedIncidentTypeData);
    const content = [];

    if (
        this.props.selectedIncidentTypeData &&
        this.props.selectedIncidentTypeData !== null &&
        this.props.selectedIncidentTypeData.REQUIREPROPERTYINFO === "Y"
    ) {
      if (doLog()) console.log("[Properties].render RequireProperty:" + this.props.selectedIncidentTypeData.REQUIREPROPERTYINFO);
        const arraySize = this.props.propertyArray.length;
        if (doLog()) console.log("[Properties].render arraySize:" + arraySize);
        if (arraySize > 0) {
          for (let i = 0; i < arraySize; i++) {
            const item = this.props.propertyArray[i];
            content.push(<Property key={item.propertyInstance} item={item} />);
          }
        }
      }

    if (doLog()) console.log("[Properties].render content:", content);

return (
    <div>
        {content}
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log('[Properties].mapStateToProps state:', state);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    incidentTypeDataList: state.trans.incidentTypeDataList,
    //
    propertyArray: state.trans.propertyArray,
    propertyTypeList: state.trans.propertyTypeList,
    propertyColorList: state.trans.propertyColorList,
    //
    stateList: state.trans.stateList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToPropertyArray: (propertyArray, propertyItem) =>
      dispatch(actions.addToPropertyArray(propertyArray, propertyItem)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
